import React from 'react'

export default function AgentPropertiesDetails() {
  return (
    <div>
      <h1>Ayush Kumar</h1>
    </div>
  )
}
